import { parseRedeemDisplayCode } from './redeemDisplayCode';

export const COUPON_QR_PREFIX = 'SGLRT-CLAIM:';

export function parseCouponScan(raw) {
  const q = String(raw || '').trim();
  if (!q) return null;
  if (q.toUpperCase().startsWith(COUPON_QR_PREFIX)) {
    return { type: 'token', value: q.slice(COUPON_QR_PREFIX.length).trim() };
  }
  if (/^\d+$/.test(q)) {
    const decoded = parseRedeemDisplayCode(q);
    if (decoded) return { type: 'claimId', value: String(decoded) };
  }
  return null;
}
